import { render, staticRenderFns } from "./ResouceItem.vue?vue&type=template&id=61a10a28&"
import script from "./ResouceItem.vue?vue&type=script&lang=js&"
export * from "./ResouceItem.vue?vue&type=script&lang=js&"
import style0 from "./ResouceItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports